<template>
  <div style="position: relative; bottom: 2em;">
    <v-footer class="footerContainer" style="height:auto">
      <v-card flat tile class="flex footerBackground">
          <v-container text-xs-center>
            <v-layout justify-center align-center row>
                <v-card class="elevation-0 transparent">
                  <v-card-text class="px-0">
                    <table class="mx-auto">
                      <tr>
                        <a href="https://www.superlinda.nl/" target="_blank" rel="noopener noreferrer">
                          <img src="../assets/DrivingForce_logo_2017_200px.png" class="footerImage">
                        </a>
                      </tr>
                    </table>
                  </v-card-text>
                </v-card>
               <v-flex v-if="$store.getters.getMobilePhoneActive" xs12>
                 <v-layout column>

                   <a style="text-decoration: none;"
                      target="_blank"
                      href="https://www.superlinda.nl">
                     <p class="subheading" style="font-size: 20px !important;">{{headerCompanyName()}}</p>
                   </a>
                 </v-layout>
               </v-flex>
              <v-flex v-else xs4>
                <v-layout column>
                  <a style="text-decoration: none;"
                     target="_blank"
                     href="https://www.superlinda.nl">
                    <p class="subheading" style="font-size: 20px !important;">{{headerCompanyName()}}</p>
                  </a>
                </v-layout>
              </v-flex>
<!--              <v-card class="elevation-0 transparent PartnerImageM" v-if="!$store.getters.getMobilePhoneActive">-->
<!--                <img data-v-110f9498="" src="/static/img/DrivingForce_logo_2017_200px.4c6cb85.png" class="PartnerImgFooter">-->
<!--                <img data-v-110f9498="" src="/static/img/DrivingForce_logo_2017_200px.4c6cb85.png" class="PartnerImgFooter">-->
<!--                <img data-v-110f9498="" src="/static/img/DrivingForce_logo_2017_200px.4c6cb85.png" class="PartnerImgFooter">-->
<!--                <img data-v-110f9498="" src="/static/img/DrivingForce_logo_2017_200px.4c6cb85.png" class="PartnerImgFooter">-->
<!--                <img data-v-110f9498="" src="/static/img/DrivingForce_logo_2017_200px.4c6cb85.png" class="PartnerImgFooter">-->
<!--                <img data-v-110f9498="" src="/static/img/DrivingForce_logo_2017_200px.4c6cb85.png" class="PartnerImgFooter">-->
<!--              </v-card>-->
            </v-layout>
            <v-flex xs12>
              <p class="mt-1">
                <a
                  @click="goToPrivacyStatement()"
                  target="_blank"
                  class="link"
                  style="text-decoration: underline;"
                >{{$translate('REGISTER_PRIVACY_STATEMENT')}}</a>
              </p>
            </v-flex>
          </v-container>



<!--        <v-layout align-start justify-space-around row>-->
<!--          -->
<!--          -->
<!--          -->
<!--          -->
<!--          <v-flex xs8 class="footerContent">-->
<!--              <v-card-text class="text-md-center text-xs-left">-->
<!--                <v-flex xs4>-->
<!--                <div class="mx-auto">-->
<!--                  <table class="mx-auto">-->
<!--                    <tr>-->
<!--                      <a href="https://www.superlinda.nl/" target="_blank" rel="noopener noreferrer">-->
<!--                        <img src="../assets/DrivingForce_logo_2017_200px.png" class="footerImage">-->
<!--                      </a>-->
<!--                    </tr>-->
<!--                  </table>-->
<!--                </div>-->
<!--                </v-flex>-->
<!--                <v-flex xs4>-->
<!--                </v-flex>-->
<!--              </v-card-text>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
        <!-- <v-card-text class="grey lighten-3">
          <div oclass="max-width-medium" style="margin:0 auto">
            <v-flex xs3>
  <v-img :src="logoImage()" alt="logo" class="logoFooter"/>
            </v-flex>
            <v-flex xs12 sm6 md6 lg6 class="footerContent">
              <v-card-text class="text-md-left text-xs-left">
                <div class="mx-auto" style="width:200px">
                  <p class="subheading">{{park}}</p>
                  <p class="footerText">{{address}}</p>
                  <a :href="`mailto:${email}`">
                    <p class="footerText">{{email}}</p>
                  </a>
                  <a href="https://www.thedrivingforce.nl/privacy-statement/" target="_blank">
                    <p class="footerText">Privacy statement - {{version}}</p>
                  </a>
                </div>
              </v-card-text>
            </v-flex>
            <v-flex xs12 sm6 md6 lg6 class="footerContent">
              <v-card-text class="text-md-center text-xs-center">
                <table class="mx-auto">
                  <tr>
                    <p>Powered by</p>
                  </tr>
                  <tr>
                    <a href="https://www.thedrivingforce.nl/">
                      <img src="../assets/DrivingForce_logo_2017_200px.png" style="width:70%">
                    </a>
                  </tr>
                </table>
              </v-card-text>
            </v-flex>
          </div>
        </v-card-text> -->
      </v-card>
    </v-footer>
  </div>
</template>


<script>
import appConfig from "../../config/app_config";
import { mapGetters } from "vuex";
import { ui_helpers } from "@/shared/ui_helpers";
export default {
  name: "cp-Footer",
  mixins: [ui_helpers],
  data() {
    return {
      park: appConfig.footerInfo.park,
      address: appConfig.footerInfo.adress,
      email: appConfig.footerInfo.email,
      version: appConfig.version
    };
  },
  watch: {
    preferences: {
      handler(prefs) {
        if (prefs.CompanyName != undefined && prefs.CompanyName != "")
          this.park = prefs.CompanyName;

        if (prefs.CompanyAddress != undefined && prefs.CompanyAddress != "")
          this.address = prefs.CompanyAddress;

        if (prefs.CompanyEmail != undefined && prefs.CompanyEmail != "")
          this.email = prefs.CompanyEmail;
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters({
      preferences: "getAccountInfo"
    })
  },
  methods: {
    goToWebsite() {
      return window.open(this.headerWebsite());
    },
    headerName() {

      if (this.$store.getters.getAccountInfo.AccountName !== "") {
        return this.$store.getters.getAccountInfo.AccountName;
      }
      return "";
    },
    headerCompanyName() {

      if (this.$store.getters.getAccountInfo.CompanyName !== "") {
        return this.$store.getters.getAccountInfo.CompanyName;
      }
      return "";
    },
    headerWebsite() {
      if (this.$store.getters.getAccountInfo.CompanyWebsite !== "") {
        return this.$store.getters.getAccountInfo.CompanyWebsite;
      }
      return "";
    },
    goToPrivacyStatement(){
      this.$router.push({
        name: 'PrivacyStatement',
        params: 'component',
      });
    },
  },
  created() {},
};
</script>

<style scoped>
.PartnerImgFooter{
  width: 3em;
  height: 3em;
  margin-right:1em;
  margin-bottom:1em;
}
.PartnerImageM{
  margin-left: 2em;
}
.footerImage{
  display: block;
  max-width:230px;
  max-height:95px;
  width: auto;
  height: auto;
  /*width: 50%;*/
  /*height: 6.5em !important;*/
  margin-top: -9%;
}
.footerContainer {
  height: auto;
  margin-left: -3.4em;
  margin-right: -3.4em;
}

.bottomt {
  margin-bottom: 0px;
  padding-bottom: 0px;
}

.test{
  background-color: red;
}


.footerText {
  margin: 0;
}

.footerContent {
  width: 100%;
  float: left;
}

.logoFooter {
  margin-top: 2em;
  margin-left: 15em;
  max-width: 12em;
  max-height: 12em;
}


@media screen and (max-width: 590px) {
  .footerContent {
    clear: both;
  }
  .marginFooterItems {
    margin: 0 auto !important;
  }
}
</style>
